"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _card = require("../../styles/card"),
    _Favourite = _interopRequireDefault(require("../../../../../Favourite")),
    _OverlayActions = _interopRequireDefault(require("./OverlayActions")),
    _OverlayButton = _interopRequireDefault(require("./OverlayButton")),
    CardOverlay = function CardOverlay(a) {
  var b = a.button,
      c = a.more,
      d = a.favourite;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("card-overlay", _card.CARD_OVERLAY)
  }, !!d && _react["default"].createElement(_Favourite["default"], d), !!c && _react["default"].createElement(_OverlayActions["default"], c), !!b && _react["default"].createElement(_OverlayButton["default"], b));
},
    _default = (0, _react.memo)(CardOverlay);

exports["default"] = _default;